import React, { Fragment } from 'react'

import {
  bool, element, elementType, object,
} from 'prop-types'

import Footer from './Footer'
import Header from './Header'

function PageLayout({
  component: Component,
  footer,
  customHeader = null,
  newRoyaltyUi = false,
  ...rest
}) {
  return (
    <Fragment>
      <div className={`l-page-content${newRoyaltyUi ? ' cgt-mt-20' : ''}`}>
        {customHeader || (
          <Header {...rest} newRoyaltyUi={newRoyaltyUi} />
        )}
        <Component {...rest} newRoyaltyUi={newRoyaltyUi} />
      </div>
      <Footer {...footer} />
    </Fragment>
  )
}

PageLayout.propTypes = {
  component: elementType.isRequired,
  footer: object.isRequired,
  customHeader: element,
  newRoyaltyUi: bool,
}

export default PageLayout
